// import axios from "axios";

// // Use environment variable for production, fallback to localhost for development
// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

// axios.defaults.baseURL = API_URL;
// axios.defaults.withCredentials = true;
// axios.defaults.timeout = 60000; // Increase timeout to 60 seconds

// // Add token to all requests
// axios.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     console.log(
//       ` ${config.method?.toUpperCase()} request to: ${config.baseURL}${config.url}`,
//     );
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

// // Handle 401 responses
// axios.interceptors.response.use(
//   (response) => {
//     console.log(` ${response.status} response from: ${response.config.url}`);
//     return response;
//   },
//   (error) => {
//     console.error(
//       ` API Error: ${error.response?.status} - ${error.config?.url}`,
//     );
//     console.error("Error details:", error.response?.data);

//     if (error.response?.status === 401) {
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");
//       window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   },
// );

// export default axios;

import axios from "axios";

// Use environment variable for production, fallback to localhost for development
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

axios.defaults.baseURL = API_URL;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 60000; // Increase timeout to 60 seconds

// Add token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // console.log(
    //   ` ${config.method?.toUpperCase()} request to: ${config.baseURL}${config.url}`,
    // );
    return config;
  },
  (error) => Promise.reject(error),
);

// Handle 401 responses
axios.interceptors.response.use(
  (response) => {
    // console.log(` ${response.status} response from: ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error(
      ` API Error: ${error.response?.status} - ${error.config?.url}`,
    );
    console.error("Error details:", error.response?.data);

    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default axios;
